import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';

const toggleDedupEndpoint = apiUrl + 'pr/toggleDedup/';

export interface ToggleDedupPayload {
  repoName: string;
  orgUUID: string;
  enable_dedup: boolean;
}

export interface ToggleDedupResponse {
  success: boolean;
  enable_dedup?: boolean;
  error?: string | null;
}

/**
 * Toggle duplicate PR review deduplication for a repository.
 */
export const toggleDedup = async (
  payload: ToggleDedupPayload
): Promise<ToggleDedupResponse> => {
  try {
    const response = await postWithAuth(toggleDedupEndpoint, {
      repoName: payload.repoName,
      orgUUID: payload.orgUUID,
      enable_dedup: payload.enable_dedup,
    });

    if (!response.ok) {
      throw new Error('Failed to toggle dedup setting');
    }

    const data = await response.json();
    if (typeof data === 'string') {
      return JSON.parse(data);
    }

    if (data?.error) {
      throw new Error(data.error);
    }

    return data;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      enable_dedup: undefined,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to toggle dedup setting',
    };
  }
};
